/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Run_DurationInputs */

const vi_irrigation_run_duration = /** @type {(inputs: Irrigation_Run_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thời lượng (phút)`)
};

/**

* @param {Irrigation_Run_DurationInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_run_duration = /** @type {((inputs?: Irrigation_Run_DurationInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Run_DurationInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_run_duration(inputs)
});